import {Constant, Recon} from '../types';

interface SerializedSettings {
    isRecon: boolean;
    reconSettings?: Recon;
    maySum: boolean;
    maydesignform: boolean;
    maxRecursiveMacro: number;
}

export const serialize = (constants: Array<Constant>) => {
    const settings: SerializedSettings = {
        isRecon: false,
        maySum: false,
        maydesignform: false,
        maxRecursiveMacro: 0
    };

    if (!constants) {
        return settings;
    }

    const data = constants[0];
    const Recon: Array<Recon> = data.Recon;

    settings.maySum = data.maysum === '1';
    settings.maydesignform = data.maydesignform === '1';
    settings.maxRecursiveMacro = Number(data.recursivemacro);

    if (Recon) {
        settings.isRecon = true;
        const {reconfirstsubtitle, reconsecondsubtitle, reconaccount} = Recon[0];

        settings.reconSettings = {
            reconfirstsubtitle,
            reconsecondsubtitle,
            reconaccount
        };
    }

    return settings;
};
